import { render, staticRenderFns } from "./Swot.vue?vue&type=template&id=4239c38e&scoped=true&"
import script from "./Swot.vue?vue&type=script&lang=js&"
export * from "./Swot.vue?vue&type=script&lang=js&"
import style0 from "./Swot.vue?vue&type=style&index=0&id=4239c38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239c38e",
  null
  
)

export default component.exports